module.exports = "/images/vendor/flag-icon-css/flags/4x3/ss.svg?67001d2a8840b34f8407526c30a399d5";